import { StringUtility } from '@common/utils';
import { IModel, ModelRecord, Model } from './Model';
import { defaultTo } from 'lodash';

export interface IClinicRoleTypeModel extends IModel {
  clinicRoleTypeId: number;
  name: string | undefined;
}

export class ClinicRoleTypeModel
  extends Model
  implements ModelRecord<IClinicRoleTypeModel>
{
  clinicRoleTypeId: number;
  name: string | undefined;
  constructor(params?: Partial<IClinicRoleTypeModel>) {
    super(params);
    this.clinicRoleTypeId = defaultTo(params?.clinicRoleTypeId, 0);
    this.name = StringUtility.SanitizeStringWithEmpty(
      defaultTo(params?.name, ''),
    );
  }
}
